module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-sm.0a58e080.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-sm.png
// module id = 2932
// module chunks = 11